import { HttpErrorResponse, HttpEventType } from '@angular/common/http';
import { Component, EventEmitter, Inject, Input, OnInit, Optional, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastService } from 'src/app/shared/services/toast.service';
import { ColumnName } from '../../models/column-name';
import { CustomerAndFileInfo } from '../../models/customer-drug-info';
import { CustomerInfo } from '../../models/customer-info';
import { DrugFileUpload } from '../../models/drug-file-upload';
import { IMToolService } from '../../services/im-tool.service';
import * as constants from 'src/app/config/app-constants';
import { AlertWizardComponent } from '../alert-wizard/alert-wizard.component';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ImToolData, ImToolFirstScreenData } from '../../services/im-tool-data.service';
import { Subject, takeUntil } from 'rxjs';
import { DrugValidation } from '../../models/validate-customer-drug';
import { ImportWizardValidateCustomerDrugListComponent } from '../import-wizard-validate-customer-drug-list/import-wizard-validate-customer-drug-list.component';
import * as XLSX from 'xlsx';
import { LaunchDarklyService } from 'src/app/shared/services/launch-darkly.service';
@Component({
    selector: 'app-import-wizard-first',
    templateUrl: './import-wizard-first.component.html',
    styleUrls: ['./import-wizard-first.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    standalone: false
})
export class ImportWizardFirstComponent implements OnInit {

  @Output() hideSide = new EventEmitter<number>();
  @Output() closeWizard = new EventEmitter<boolean>();
  @Output() parentFileName = new EventEmitter<string>();
  @Output() noUsageChange = new EventEmitter<boolean>();
  @Output() isCustomerMnemonicChange = new EventEmitter<boolean>();
  devices = ImToolData.devices;
  countries = ImToolData.countries;
  get datasourceList() {
    return ImToolData.getDatasourceList(this.deviceId?.value);
  }
  ndcLabel = ImToolFirstScreenData.ndcLabels;
  ndcLabelForCanada = ImToolFirstScreenData.ndcLabelsCanada;
  fileuploadObject!: DrugFileUpload;
  customerId: string;

  columnNameList: ColumnName[] = [];
  @Output() deviceIdChange = new EventEmitter<number>()

  @Output() countryIdChange = new EventEmitter<number>()
  @Output() dataSourceIdChange = new EventEmitter<number>()
  @Input() customerData: CustomerInfo[] = [];
  errorMessages: [] = [];
  private destroy$ = new Subject<void>();
  private readonly drugValidationFlagKeys = [
    'drug-validation-wizard-feature'
  ];
  private readonly parataLegacyConnectFlagKeys = [
    'parata-legacy-connect-feature'
  ];

  drugValidationData : DrugValidation[]=[];
  isDrugValidationEnabled = false;
  isParataLegacyConnectEnabled = false;

  customerAndFileInfoModel!: CustomerAndFileInfo;

  // File Upload Information form
  drugFileInfoForm!: FormGroup;
  mappedDrugName: FormControl;
  mappedSecondaryDrugName: FormControl;
  mappedNDC: FormControl;
  mappedMnemonic: FormControl;
  mappedUsage: FormControl;
  mappedNoOfOrders: FormControl;
  primaryDrugName!: FormControl;
  secondaryDrugName!: FormControl;
  mappedSuperCellSelect: FormControl;
  mappedAtpLot: FormControl;
  mappedRanking: FormControl;
  mappedAtpDrugExpirationDate: FormControl;
  mappedCustomerQuantity: FormControl;
  mappedAtpDeviceLocation: FormControl;
  mappedAtpPillDescription: FormControl;
  mappedAtpPillColor: FormControl;
  mappedAtpPillShape: FormControl;
  mappedAtpImp1: FormControl;
  mappedAtpImp2: FormControl;
  mappedExternalDrugFlag: FormControl;
  mappedCustomerBarcode: FormControl;
  isCustomerMnemonic: FormControl;
  mappedLockingCell: FormControl;
  mappedCustomerInventoryNumber: FormControl;
  mappedCustomerComment: FormControl;
  mappedCustomerOtc: FormControl;
  mappedNdcLabel: FormControl;
  mappedStrength: FormControl;
  mappedAhsfClass: FormControl;
  mappedCost: FormControl;
  mappedPackageOrderNumber: FormControl;
  mappedAtpHighCapCanister: FormControl;
  mappedAtpSmartCanister: FormControl;
  mappedLid: FormControl;
  mappedLidVolcanic: FormControl;
  mappedPipetteSize: FormControl;
  mappedToggleFlag: FormControl;
  mappedMassIndex: FormControl;
  mappedContainerId: FormControl;
  mappedFragileFlag: FormControl;
  mappedContainerSize: FormControl;
  mappedCustomerUpc: FormControl;
  mappedProductId: FormControl;
  mappedProductScanCode: FormControl;
  mappedGtin: FormControl;
  mappedPackSize: FormControl;
  mappedPurchaseQty: FormControl;
  mappedDrugSchedule: FormControl;
  mappedDrugForm: FormControl;
  mappedProductType: FormControl;
  mappedUomClass: FormControl;
  mappedSellUom: FormControl;
  mappedCapacity: FormControl;
  mappedExpDate: FormControl;
  mappedOrmd: FormControl;
  mappedRefrigerateFlag: FormControl;
  mappedIsOralSolid: FormControl;
  mappedSlotArea: FormControl;
  mappedSlotShelf: FormControl;
  mappedSlotBin: FormControl;
  mappedLocType: FormControl;
  mappedRop: FormControl;
  mappedQtyonShelf: FormControl;
  mappedLotNo: FormControl;
  mappedVialSize: FormControl;
  mappedVialCapacity: FormControl;
  mappedVialEnabled: FormControl;
  mappedVendorPartNo: FormControl;
  mappedSpecialty: FormControl;
  mappedRank: FormControl;
  mappedNA: FormControl;
  mappedThirtyDramCapacity: FormControl;
  mappedMaxRecomendedforUse: FormControl;
  mappedCellCapacitySmall: FormControl;
  mappedCellCapacityLarge: FormControl;
  // File operation related variables
  fileContent: string = "";
  percentage: number = 0;
  fielName: string = "";
  fieleSelect: boolean = false;
  fileUploadButtonShow: boolean = true;
  backgroundcolor: string = "green";
  excelPreviewData: any[][] = [];

  //#endregion



  noUsage: FormControl;
  orderOrUsage: FormControl;
  usageValue: FormControl;
  deviceId!: FormControl;
  countryId!: FormControl;
  dataSourceId: FormControl;
  constructor(
    private imtoolService: IMToolService,
    private ngxLoader: NgxUiLoaderService,
    private toastService: ToastService,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private launchDarklyService: LaunchDarklyService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.customerData.push(data.customer);
    this.noUsage = new FormControl(false);
    this.orderOrUsage = new FormControl(1);
    this.mappedNdcLabel = new FormControl(1);
    this.usageValue = new FormControl(2)
    this.dataSourceId = new FormControl(5, Validators.required);
    this.mappedDrugName = new FormControl("", Validators.required);
    this.mappedSecondaryDrugName = new FormControl("");
    this.mappedNDC = new FormControl("", Validators.required);
    this.mappedMnemonic = new FormControl("");
    this.mappedUsage = new FormControl("", Validators.required);
    this.mappedSuperCellSelect = new FormControl("", Validators.required)

    this.mappedNoOfOrders = new FormControl("");
    this.mappedAtpLot = new FormControl();
    this.mappedRanking = new FormControl();
    this.mappedAtpDrugExpirationDate = new FormControl();
    this.mappedCustomerQuantity = new FormControl();
    this.mappedAtpDeviceLocation = new FormControl();
    this.mappedAtpPillDescription = new FormControl();
    this.mappedAtpPillColor = new FormControl();
    this.mappedAtpPillShape = new FormControl();
    this.mappedAtpImp1 = new FormControl();
    this.mappedAtpImp2 = new FormControl();
    this.mappedCustomerBarcode = new FormControl();
    this.mappedLockingCell = new FormControl();
    this.mappedCustomerInventoryNumber = new FormControl();
    this.mappedCustomerComment = new FormControl();
    this.mappedCustomerOtc = new FormControl();
    this.isCustomerMnemonic = new FormControl(false);
    this.customerId = this.customerData[0].customerId;
    this.mappedExternalDrugFlag = new FormControl();
    this.mappedStrength = new FormControl();
    this.mappedAhsfClass = new FormControl();
    this.mappedCost = new FormControl();
    this.mappedPackageOrderNumber = new FormControl();
    this.mappedAtpHighCapCanister = new FormControl();
    this.mappedAtpSmartCanister = new FormControl();
    this.mappedLid = new FormControl();
    this.mappedLidVolcanic = new FormControl();
    this.mappedPipetteSize = new FormControl();
    this.mappedToggleFlag = new FormControl();
    this.mappedMassIndex = new FormControl();
    this.mappedContainerId = new FormControl();
    this.mappedFragileFlag = new FormControl();
    this.mappedContainerSize = new FormControl();
    this.mappedCustomerUpc = new FormControl();
    this.mappedProductId = new FormControl();
    this.mappedProductScanCode = new FormControl();
    this.mappedGtin = new FormControl();
    this.mappedPackSize = new FormControl();
    this.mappedPurchaseQty = new FormControl();
    this.mappedDrugSchedule = new FormControl();
    this.mappedDrugForm = new FormControl();
    this.mappedProductType = new FormControl();
    this.mappedUomClass = new FormControl();
    this.mappedSellUom = new FormControl();
    this.mappedCapacity = new FormControl();
    this.mappedExpDate = new FormControl();
    this.mappedOrmd = new FormControl();
    this.mappedRefrigerateFlag = new FormControl();
    this.mappedIsOralSolid = new FormControl();
    this.mappedSlotArea = new FormControl();
    this.mappedSlotShelf = new FormControl();
    this.mappedSlotBin = new FormControl();
    this.mappedLocType = new FormControl();
    this.mappedRop = new FormControl();
    this.mappedQtyonShelf = new FormControl();
    this.mappedLotNo = new FormControl();
    this.mappedVialSize = new FormControl();
    this.mappedVialCapacity = new FormControl();
    this.mappedVialEnabled = new FormControl();
    this.mappedVendorPartNo = new FormControl();
    this.mappedSpecialty = new FormControl();
    this.mappedRank = new FormControl();
    this.mappedNA = new FormControl();
    this.mappedThirtyDramCapacity = new FormControl();
    this.mappedMaxRecomendedforUse = new FormControl();
    this.mappedCellCapacitySmall = new FormControl();
    this.mappedCellCapacityLarge = new FormControl();

  }

  ngOnInit(): void {

    this.deviceId = new FormControl(1);
    this.countryId = new FormControl(1);
    this.deviceIdChange.emit(1)
    this.countryIdChange.emit(1)
    this.drugFileInfoForm = this.fb.group({
      countryId: this.countryId,
      deviceId: this.deviceId,
      dataSourceId: this.dataSourceId,
      mappedExternalDrugFlag: this.mappedExternalDrugFlag,
      mappedNdcLabel: this.mappedNdcLabel,
      mappedDrugName: this.mappedDrugName,
      mappedSecondaryDrugName: this.mappedSecondaryDrugName,
      mappedNDC: this.mappedNDC,
      mappedMnemonic: this.mappedMnemonic,
      mappedSuperCellSelect: this.mappedSuperCellSelect,
      mappedUsage: this.mappedUsage,
      mappedNoOfOrders: this.mappedNoOfOrders,
      mappedAtpLot: this.mappedAtpLot,
      mappedRanking: this.mappedRanking,
      mappedAtpDeviceLocation: this.mappedAtpDeviceLocation,
      mappedAtpDrugExpirationDate: this.mappedAtpDrugExpirationDate,
      mappedCustomerQuantity: this.mappedCustomerQuantity,
      mappedAtpPillDescription: this.mappedAtpPillDescription,
      mappedAtpPillColor: this.mappedAtpPillColor,
      mappedAtpPillShape: this.mappedAtpPillShape,
      mappedAtpImp1: this.mappedAtpImp1,
      mappedAtpImp2: this.mappedAtpImp2,
      mappedCustomerBarcode: this.mappedCustomerBarcode,

      mappedLockingCell: this.mappedLockingCell,
      mappedCustomerInventoryNumber: this.mappedCustomerInventoryNumber,
      mappedCustomerComment: this.mappedCustomerComment,
      mappedCustomerOtc: this.mappedCustomerOtc,
      orderOrUsage: this.orderOrUsage,
      usageValue: this.usageValue,
      noUsage: this.noUsage,
      isCustomerMnemonic: this.isCustomerMnemonic,
      mappedStrength: this.mappedStrength,
      mappedAhsfClass: this.mappedAhsfClass,
      mappedCost: this.mappedCost,
      mappedPackageOrderNumber: this.mappedPackageOrderNumber,
      mappedAtpHighCapCanister: this.mappedAtpHighCapCanister,
      mappedAtpSmartCanister: this.mappedAtpSmartCanister,
      mappedLid: this.mappedLid,
      mappedLidVolcanic:this.mappedLidVolcanic,
      mappedPipetteSize:this.mappedPipetteSize,
      mappedToggleFlag:this.mappedToggleFlag,
      mappedMassIndex:this.mappedMassIndex,
      mappedContainerId: this.mappedContainerId,
      mappedFragileFlag:this.mappedFragileFlag,
      mappedContainerSize:this.mappedContainerSize,
      mappedCustomerUpc:this.mappedCustomerUpc,
      mappedProductId: this.mappedProductId,
      mappedProductScanCode: this.mappedProductScanCode,
      mappedGtin: this.mappedGtin,
      mappedPackSize: this.mappedPackSize,
      mappedPurchaseQty: this.mappedPurchaseQty,
      mappedDrugSchedule: this.mappedDrugSchedule,
      mappedDrugForm: this.mappedDrugForm,
      mappedProductType: this.mappedProductType,
      mappedUomClass: this.mappedUomClass,
      mappedSellUom: this.mappedSellUom,
      mappedCapacity: this.mappedCapacity,
      mappedExpDate: this.mappedExpDate,
      mappedOrmd: this.mappedOrmd,
      mappedRefrigerateFlag: this.mappedRefrigerateFlag,
      mappedIsOralSolid: this.mappedIsOralSolid,
      mappedSlotArea: this.mappedSlotArea,
      mappedSlotShelf: this.mappedSlotShelf,
      mappedSlotBin: this.mappedSlotBin,
      mappedLocType: this.mappedLocType,
      mappedRop: this.mappedRop,
      mappedQtyonShelf: this.mappedQtyonShelf,
      mappedLotNo: this.mappedLotNo,
      mappedVialSize: this.mappedVialSize,
      mappedVialCapacity: this.mappedVialCapacity,
      mappedVialEnabled: this.mappedVialEnabled,
      mappedVendorPartNo: this.mappedVendorPartNo,
      mappedSpecialty: this.mappedSpecialty,
      mappedRank: this.mappedRank,
      mappedNA: this.mappedNA,
      mappedThirtyDramCapacity: this.mappedThirtyDramCapacity,
      mappedMaxRecomendedforUse: this.mappedMaxRecomendedforUse,
      mappedCellCapacitySmall: this.mappedCellCapacitySmall,
      mappedCellCapacityLarge: this.mappedCellCapacityLarge,
    });
    this.formValidataionUpdate();

    this.drugFileInfoForm.get('deviceId')!.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        this.updateColumnList()
      });

    this.drugFileInfoForm.get('dataSourceId')!.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        this.dataSourceIdChange.emit(Number(value));
      });

    const initialDataSource = this.getDefaultDataSource(this.deviceId.value, this.countryId.value);
    this.dataSourceId.setValue(initialDataSource);
    this.dataSourceIdChange.emit(initialDataSource);

    this.setUsageValue();
    this.listenForDrugValidationFeatureFlag();
    this.listenForParataLegacyConnectFeatureFlag();


  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private listenForDrugValidationFeatureFlag(): void {
    this.isDrugValidationEnabled = this.resolveDrugValidationFlag();

    this.launchDarklyService?.flagChange
      .pipe(takeUntil(this.destroy$))
      .subscribe((flags: Record<string, unknown>) => {
        this.isDrugValidationEnabled = this.resolveDrugValidationFlag(flags);
      });
  }


  private resolveDrugValidationFlag(flags?: Record<string, unknown>): boolean {
    for (const key of this.drugValidationFlagKeys) {
      if (flags && Object.prototype.hasOwnProperty.call(flags, key)) {
        return Boolean(flags[key]);
      }
    }

    return this.launchDarklyService.getBooleanFlag(this.drugValidationFlagKeys[0], false);
  }

  isDrugValidationActive(): boolean {
    return this.isDrugValidationEnabled && Number(this.countryId?.value) === 1;
  }

  private listenForParataLegacyConnectFeatureFlag(): void {
    this.isParataLegacyConnectEnabled = this.resolveParataLegacyConnectFlag();

    this.launchDarklyService?.flagChange
      .pipe(takeUntil(this.destroy$))
      .subscribe((flags: Record<string, unknown>) => {
        this.isParataLegacyConnectEnabled = this.resolveParataLegacyConnectFlag(flags);
      });
  }

  private resolveParataLegacyConnectFlag(flags?: Record<string, unknown>): boolean {
    for (const key of this.parataLegacyConnectFlagKeys) {
      if (flags && Object.prototype.hasOwnProperty.call(flags, key)) {
        return Boolean(flags[key]);
      }
    }

    return this.launchDarklyService.getBooleanFlag(this.parataLegacyConnectFlagKeys[0], false);
  }

  isParataLegacyConnectActive(): boolean {
    return this.isParataLegacyConnectEnabled;
  }

  isDisabledHccAndScc() {
    return this.mappedAtpDeviceLocation.value?.length > 0
  }

  isUsaOrCanadaMaxDevice(): boolean {
    const countryId = Number(this.countryId?.value);
    return (countryId === 1 || countryId === 2) && Number(this.deviceId?.value) === 1;
  }

  isSuperCellSelectDisabled(): boolean {
    return !this.isUsaOrCanadaMaxDevice() && this.drugFileInfoForm.get('noUsage')?.value == false;
  }

  setUsageValue() {
    this.drugFileInfoForm.controls['orderOrUsage'].setValue(1);
    this.drugFileInfoForm.controls['usageValue'].setValue(2);

  }

  updateColumnList() {
    this.columnNameList = this.columnNameList
      .map(column => ({ ...column, name: this.normalizeColumnName(column.name) }))
      .filter(
        column => !ImToolData.columnList.some(
          item => item.name.toLowerCase() === column.name.toLowerCase()
        )
      );

    if (this.deviceId.value === 1 || this.deviceId.value === 5) {
      ImToolData.columnList.forEach(object => {
        this.columnNameList.push(object)
      })
    }
    if (this.deviceId.value === 3 || this.deviceId.value === 2 || this.deviceId.value === 4) {
      const firstObject = ImToolData.columnList[0];  // Get the first object
      if (firstObject) {
        this.columnNameList.push(firstObject);  // Push only the first object
      }
    }


  }

  private normalizeColumnName(name: string): string {
    return (name ?? '').toString().trim();
  }

  updateTheForm(value: number) {
    const countryId = Number(this.drugFileInfoForm.get('countryId')?.value ?? 1);
    const defaultDataSource = this.getDefaultDataSource(value, countryId);

    this.drugFileInfoForm.reset({
      deviceId: value,
      countryId: countryId,
      dataSourceId: defaultDataSource
    })
    this.deviceIdChange.emit(value)
    this.dataSourceIdChange.emit(defaultDataSource)
    this.setUsageValue();
    this.formValidataionUpdate();
    this.updateColumnList();
    if (this.countryId.value == 1) {
      this.drugFileInfoForm.controls['mappedNdcLabel'].setValue(1);
    }
    else if (this.countryId.value == 2) {
      this.drugFileInfoForm.controls['mappedNdcLabel'].setValue(4);
    }
  }

  updateTheFormForCountry(value: number) {
    const deviceId = Number(this.drugFileInfoForm.get('deviceId')?.value ?? 1);
    const defaultDataSource = this.getDefaultDataSource(deviceId, value);
    this.drugFileInfoForm.reset({
      countryId: value,
      deviceId: deviceId,
      dataSourceId: defaultDataSource
    })
    this.countryIdChange.emit(value)
    this.dataSourceIdChange.emit(defaultDataSource)
    this.setUsageValue();
    this.formValidataionUpdate();
    this.updateColumnList();

    if (this.countryId.value == 1) {
      this.drugFileInfoForm.controls['mappedNdcLabel'].setValue(1);
    }
    else if (this.countryId.value == 2) {
      this.drugFileInfoForm.controls['mappedNdcLabel'].setValue(4);
    }
  }

  isEmpty(obj: Record<string, any>): boolean {
    return Object.keys(obj).length === 0;
  }

  private getDefaultDataSource(deviceId: number, countryId: number): number {
    if (countryId === 2) {
      return 4; // DPD(CAN)
    }
    if (deviceId === 3) {
      return 1; // FDB for ATP
    }
    return 5; // Medispan default
  }
  
  updateNoUsage() {

    if (this.mappedUsage.value === 'No Usage Data Provided' || this.mappedNoOfOrders.value === 'No Usage Data Provided') {
      this.noUsage.setValue(true);
      this.noUsageChange.emit(true)
      this.mappedNoOfOrders.setValue('No Usage Data Provided');
      this.mappedUsage.setValue('No Usage Data Provided');
    }
    else {
      this.noUsage.setValue(false);
      this.noUsageChange.emit(false)
    }
    this.formValidataionUpdate();
  }

  formValidataionUpdate() {
    if (this.noUsage.value !== true) {
      if (this.deviceId.value !== 7) {
        this.drugFileInfoForm.controls["mappedUsage"].setValidators(Validators.required);
      }
      else {
        this.drugFileInfoForm.controls["mappedUsage"].clearValidators();
        this.drugFileInfoForm.controls["mappedNoOfOrders"].clearValidators();
      }
      this.drugFileInfoForm.controls["mappedSuperCellSelect"].clearValidators();
      if (!this.isUsaOrCanadaMaxDevice()) {
        this.drugFileInfoForm.controls["mappedSuperCellSelect"].reset();
      }

    }
    else {
      this.drugFileInfoForm.controls["mappedUsage"].clearValidators();
      this.drugFileInfoForm.controls["mappedNoOfOrders"].clearValidators();
      this.drugFileInfoForm.controls["mappedUsage"].reset();
      if (this.deviceId.value === 3) {
        //this.drugFileInfoForm.controls["mappedAtpDeviceLocation"].setValidators(Validators.required);
      }
      else {
        this.drugFileInfoForm.controls["mappedAtpDeviceLocation"].clearValidators();
        this.drugFileInfoForm.controls["mappedAtpDeviceLocation"].reset();
      }
    }
    this.drugFileInfoForm.controls["mappedUsage"].updateValueAndValidity()
    this.drugFileInfoForm.controls["mappedNoOfOrders"].updateValueAndValidity()
    this.drugFileInfoForm.controls["mappedSuperCellSelect"].updateValueAndValidity()
    this.drugFileInfoForm.controls["mappedAtpDeviceLocation"].updateValueAndValidity()
  }

  isUndefined(variable: unknown): boolean {
    return typeof variable === 'undefined' || variable === null

  }
  isAlphabetical(deviceId: number, usage: string, noOfOrder: string): boolean {
    if (deviceId == 1) {
      return this.mappedRanking.value == 'Alphabetical(max only)' ? true : false;
    }
    else if (deviceId == 2 && (usage === 'No Usage Data Provided' || noOfOrder === 'No Usage Data Provided')) {
      return (this.mappedRanking.value != '' && this.mappedRanking.value != null) ? false : true;
    }
    else if (deviceId == 3) {

      if (usage === 'No Usage Data Provided' || noOfOrder === 'No Usage Data Provided') {
        return true;
      }
      else {
        return false;
      }
    }
    return false;
  }

  isOpenAlertWizard() {
    if ((this.deviceId.value == 3)
      && (this.mappedUsage.value === 'No Usage Data Provided' || this.mappedNoOfOrders.value === 'No Usage Data Provided')
      && (this.mappedRanking.value === null || this.mappedRanking.value === '')
      && (this.mappedAtpDeviceLocation.value === null || this.mappedAtpDeviceLocation.value === '')
    ) {
      this.openAlertWizardForAtpNoUsage();
    }
    else if ([1, 5].includes(Number(this.deviceId.value))
      && this.noUsage.value === true
      && !this.mappedSuperCellSelect.value
    ) {
      this.openAlertWizardForMaxNoUsage();
    }
    else {
      this.customerAndFileInfoSave();
    }
  }

  /**
   * Open Drug Validation Wizard for drug validation
   * This is called after successful API response from customerAndFileInfoSave
   */
  openDrugValidationWizard() {
    if (!this.isDrugValidationActive()) {
      this.hideSide.emit(2);
      return;
    }

    // The drug validation data comes from the API response and has been transformed
    
    const dialogRef = this.dialog.open(ImportWizardValidateCustomerDrugListComponent, {
      panelClass: 'drug-validation-wizard-dialog',
      width: '95vw',
      maxWidth: '1800px',
      height: '90vh',
      disableClose: true,
      data: {
        inputDatalist: this.drugValidationData,
        customerId: this.customerData[0].customerId
      },
    });
    
    dialogRef.afterClosed().subscribe((result) => {
      console.log('===== VALIDATION DIALOG CLOSED (OLD HANDLER) =====');
      console.log('Result:', result);
      
      if (result && (result.navigateToWI2 || result.data)) {
        console.log('EMITTING hideSide(2) to navigate to WI2');
        this.hideSide.emit(2);
        console.log('hideSide(2) emitted');
      } else {
        console.log("Drug validation cancelled or no data");
      }
      console.log('===== END OLD HANDLER =====');
    });
  }





  /**
   * Process validated drugs after Drug Validation Wizard
   */
  private processValidatedDrugs(validatedDrugs: any[]) {
    const acceptedDrugs = validatedDrugs.filter(d => d.action === 'Accept');
    const newDrugs = validatedDrugs.filter(d => d.action === 'New Drug');
    const excludedDrugs = validatedDrugs.filter(d => d.action === 'Exclude');
    const nonOralSolidDrugs = validatedDrugs.filter(d => d.action === 'Non-Oral Solid');

    console.log('Accepted Drugs:', acceptedDrugs.length);
    console.log('New Drugs:', newDrugs.length);
    console.log('Excluded Drugs:', excludedDrugs.length);
    console.log('Non-Oral Solid Drugs:', nonOralSolidDrugs.length);

    // Show success message
    this.toastService.openToast(
      `Drug validation completed. ${acceptedDrugs.length} drugs accepted, ${newDrugs.length} new drugs to create.`,
      constants.ToastPanelType.done,
      3
    );
  }

  /**
   * Transform API response to DrugValidation format.
   * Supports both:
   * 1) New format: { customerNdc, matched_ndcs_output, customerDrugName, cddbDrugName, matchCount }
   * 2) Legacy format: { ndc, matches: [{ drugName, newDrugNumber, matchCount }] }
   */
  private transformApiResponseToDrugValidation(apiData: any[]): DrugValidation[] {
    if (!apiData || apiData.length === 0) {
      return [];
    }

    const transformedData: DrugValidation[] = [];
    console.log('API data for validation screen:', JSON.stringify(apiData, null, 2));
    
    apiData.forEach(item => {
      if (item && Object.prototype.hasOwnProperty.call(item, 'customerNdc')) {
        const ndc = item.customerNdc;
        const customerDrugName = item.customerDrugName || '';
        const cddbDrugName = item.cddbDrugName || null;
        const strength = item.strength || null;
        const uom = item.uom || null;
        const matchCount = Number(item.matchCount || 0);
        const matchedNdcsOutput = item.matched_ndcs_output || null;
        const matchedNdcs = matchedNdcsOutput
          ? matchedNdcsOutput.split(',').map((x: string) => x.trim()).filter((x: string) => !!x)
          : [];

        if (matchCount <= 0 || matchedNdcs.length === 0) {
          transformedData.push({
            customerDrugName,
            customerNdc: ndc,
            cddbDrugName,
            matchNdc1: null,
            matchNdc2: null,
            matchNdc3: null,
            status: 'None',
            selectedMatchNdc: undefined,
            matchCount: 0,
            action: 'New Drug',
            isCorrected: true,
            strength,
            uom,
            usage: item.usage || 0
          });
        } else if (matchCount === 1 || matchedNdcs.length === 1) {
          const selectedNdc = matchedNdcs[0] || matchedNdcsOutput;
          transformedData.push({
            customerDrugName,
            customerNdc: ndc,
            cddbDrugName,
            strength,
            uom,
            matchNdc1: selectedNdc,
            matchNdc2: null,
            matchNdc3: null,
            status: 'Exact',
            selectedMatchNdc: selectedNdc,
            matchCount: 1,
            action: 'Accept',
            isCorrected: true,
            usage: item.usage || 0
          });
        } else {
          transformedData.push({
            customerDrugName,
            customerNdc: ndc,
            cddbDrugName,
            strength,
            uom,
            matchNdc1: matchedNdcs.join(','),
            matchNdc2: null,
            matchNdc3: null,
            status: 'Multiple',
            selectedMatchNdc: undefined,
            matchCount,
            action: undefined,
            isCorrected: false,
            usage: item.usage || 0
          });
        }

        return;
      }

      const ndc = item.ndc;
      const rawMatches = item.matches || [];

      const hasValidMatches =
        rawMatches.length > 0 &&
        rawMatches[0].matchCount > 0 &&
        rawMatches[0].newDrugNumber !== null &&
        rawMatches[0].newDrugNumber !== '';

      if (!hasValidMatches) {
        const drugName = (rawMatches.length > 0 && rawMatches[0].drugName) ? rawMatches[0].drugName : '';

        transformedData.push({
          customerDrugName: drugName,
          customerNdc: ndc,
          cddbDrugName: drugName || null,
          strength: item.strength || null,
          uom: item.uom || null,
          matchNdc1: null,
          matchNdc2: null,
          matchNdc3: null,
          status: 'None',
          selectedMatchNdc: undefined,
          matchCount: 0,
          action: 'New Drug',
          isCorrected: true,
          usage: item.usage || 0
        });
      } else if (rawMatches.length === 1) {
        const match = rawMatches[0];
        transformedData.push({
          customerDrugName: match.drugName || '',
          customerNdc: ndc,
          cddbDrugName: match.drugName || '',
          strength: match.strength || null,
          uom: match.uom || null,
          matchNdc1: match.newDrugNumber || null,
          matchNdc2: null,
          matchNdc3: null,
          status: 'Exact',
          selectedMatchNdc: match.newDrugNumber || null,
          matchCount: 1,
          action: 'Accept',
          isCorrected: true,
          usage: item.usage || 0
        });
      } else {
        const firstMatch = rawMatches[0];
        const matchNdcs = rawMatches
          .map((m: any) => m.newDrugNumber)
          .filter((ndcVal: any) => ndcVal && ndcVal !== '')
          .join(',');

        transformedData.push({
          customerDrugName: firstMatch.drugName || '',
          customerNdc: ndc,
          cddbDrugName: firstMatch.drugName || '',
          strength: firstMatch.strength || null,
          uom: firstMatch.uom || null,
          matchNdc1: matchNdcs,
          matchNdc2: null,
          matchNdc3: null,
          status: 'Multiple',
          selectedMatchNdc: undefined,
          matchCount: rawMatches.length,
          action: undefined,
          isCorrected: false,
          usage: item.usage || 0
        });
      }
    });

    return transformedData;
  }



  openAlertWizardForMaxNoUsage() {
    const dialogRef = this.dialog.open(AlertWizardComponent, {
      backdropClass: ['smDialog'],
      disableClose: true,
      data: {
        alertIcon: "/assets/img/icons/ico.16.warning.svg",
        title: Number(this.deviceId.value) === 5 ? "Mini No Usage Configuration" : "Max No Usage Configuration",
        bodyMessage: "If you continue without selecting a supercell column, your supercells will be assigned as per the system configuration. Do you wish to continue or go back?",
        bodyMessage2: "",
        cancelBtnText: "Go Back",
        confirmBtnText: "Continue",
        confirmButtonColor: "btn-light-blue",
        cancelButtonColor: "btn-light-red",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result?.data === true) {
        this.customerAndFileInfoSave();
      }
    });
  }

  openAlertWizardForAtpNoUsage() {
    const dialogRef = this.dialog.open(AlertWizardComponent, {
      backdropClass: ['smDialog'],
      disableClose: true,
      data: {
        alertIcon: "/assets/img/icons/ico.16.warning.svg",
        title: "ATP No Usage Configuration",
        bodyMessage: "No Usage Data, Ranking or Device Location was Mapped for this project. If you Proceed Canisters will be assigned locations based on their drug name Alphabetically. do you wish to proceed or go back?",
        bodyMessage2: "",
        cancelBtnText: "Cancel",
        confirmBtnText: "Continue",
        confirmButtonColor: "btn-light-blue",
        cancelButtonColor: "btn-light-red",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.data == true) {
        this.customerAndFileInfoSave();
      }
    });
  }

  fileUpload() {
    const FILEUPLOAD_KEY = 'Fileuploadkey'
    if (this.fileuploadObject.FileContent.length > 0) {
      this.fileUploadButtonShow = false;
      this.ngxLoader.start(FILEUPLOAD_KEY);
      this.imtoolService.create(this.fileuploadObject).subscribe(
        (result) => {
          this.ngxLoader.stop(FILEUPLOAD_KEY);
          this.progressbarShow(result);
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop(FILEUPLOAD_KEY);
          this.toastService.openToast(
            "Failed to upload the file.",
            constants.ToastPanelType.error,
            2
          );
          setTimeout(() => {
            this.percentage = 0;
          }, 2000);
        }
      );
    }
  }


  onDataSourceSelected(sourceId: number): void {
    if (Number(sourceId) !== 5 || Number(this.deviceId.value) !== 3) {
      return;
    }
    const dialogRef = this.dialog.open(AlertWizardComponent, {
      backdropClass: ['smDialog'],
      disableClose: true,
      data: ImToolData.legacyAtpWkWarningDialog,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result?.data !== true) {
        this.dataSourceId.setValue(1);
      }
    });
  }

  customerAndFileInfoSave() {
    let formValue = this.drugFileInfoForm.value;
    this.parentFileName.emit(this.fielName)
    this.customerAndFileInfoModel = {
      customerId: this.customerData[0].customerId,
      fileContent: this.fileContent,
      fileName: this.fielName,
      customerName: this.customerData[0].customerName,
      caseNumber: this.customerData[0].caseNumber,
      customerNumber: this.customerData[0].customerNumber,
      assetNumber: this.customerData[0].assetNumber,
      deviceId: Number(formValue.deviceId ?? this.deviceId?.value ?? this.customerData[0].deviceId ?? 1),
      deviceType:
        this.customerData[0].deviceType == null
          ? ""
          : this.customerData[0].deviceType.subDeviceTypeName,
      targetInstallDate: this.customerData[0].targetInstallDate,
      uploadedBy: "",
      statusId: this.customerData[0].status.id,
      mappedDrugName: formValue.mappedDrugName,
      mappedSecondaryDrugName: formValue.mappedSecondaryDrugName,
      mappedNDC: formValue.mappedNDC,
      mappedNdc: formValue.mappedNDC,
      mappedMnemonic: formValue.mappedMnemonic,
      mappedUsage: formValue.mappedUsage,
      mappedNoOfOrders: formValue.mappedNoOfOrders,
      mappedSuperCell: formValue.mappedSuperCellSelect,
      mappedAtpLot: formValue.mappedAtpLot,
      mappedAtpDeviceLocation: formValue.mappedAtpDeviceLocation,
      mappedAtpDrugExpirationDate: formValue.mappedAtpDrugExpirationDate,
      mappedCustomerQuantity: formValue.mappedCustomerQuantity,
      mappedAtpPillDescription: formValue.mappedAtpPillDescription,
      mappedAtpPillColor: formValue.mappedAtpPillColor,
      mappedAtpPillShape: formValue.mappedAtpPillShape,
      mappedAtpImp1: formValue.mappedAtpImp1,
      mappedAtpImp2: formValue.mappedAtpImp2,
      mappedRanking: formValue.mappedRanking,
      mappedCustomerBarcode: formValue.mappedCustomerBarcode,

      mappedLockingCell: formValue.mappedLockingCell,
      mappedCustomerInventoryNumber: formValue.mappedCustomerInventoryNumber,
      mappedCustomerComment: formValue.mappedCustomerComment,
      mappedCustomerOtc: formValue.mappedCustomerOtc,
      mappedNdcLabel: formValue.mappedNdcLabel,
      noSuperCell: this.mappedSuperCellSelect.value === 'No Super cell' ? true : false,

      //isAlphabeticalOrder: this.mappedRanking.value == 'Alphabetical(max only)'?true:false ,

      isAlphabeticalOrder: this.isAlphabetical(this.deviceId.value, formValue.mappedNoOfOrders, formValue.mappedUsage),
      orderOrUsage: formValue.orderOrUsage == 1 ? true : false,
      noUsage: formValue.noUsage === undefined || formValue.noUsage === null ? false : formValue.noUsage,
      isCustomerMnemonic: Boolean(formValue.isCustomerMnemonic),
      mappedExternalDrugFlag: formValue.mappedExternalDrugFlag,
      mappedStrength: formValue.mappedStrength,
      mappedAhsfClass: formValue.mappedAhsfClass ?? null,
      mappedCost: formValue.mappedCost ?? null,
      mappedPackageOrderNumber: formValue.mappedPackageOrderNumber,
      mappedAtpSmartCanister: formValue.mappedAtpSmartCanister,
      mappedLid: formValue.mappedLid,
      mappedLidVolcanic: formValue.mappedLidVolcanic,
      mappedPipetteSize:formValue.mappedPipetteSize,
      mappedToggleFlag:formValue.mappedToggleFlag,
      mappedMassIndex:formValue.mappedMassIndex,
      mappedContainerId: formValue.mappedContainerId,
      mappedFragileFlag:formValue.mappedFragileFlag,
      mappedContainerSize:formValue.mappedContainerSize,
      mappedCustomerUpc:formValue.mappedCustomerUpc,
      mappedAtpHighCapCanister: formValue.mappedAtpHighCapCanister,
      mappedProductId: formValue.mappedProductId,
      mappedProductScanCode: formValue.mappedProductScanCode,
      mappedGtin: formValue.mappedGtin,
      mappedPackSize: formValue.mappedPackSize,
      mappedPurchaseQty: formValue.mappedPurchaseQty,
      mappedDrugSchedule: formValue.mappedDrugSchedule,
      mappedDrugForm: formValue.mappedDrugForm,
      mappedProductType: formValue.mappedProductType,
      mappedUomClass: formValue.mappedUomClass,
      mappedSellUom: formValue.mappedSellUom,
      mappedCapacity: formValue.mappedCapacity,
      mappedExpDate: formValue.mappedExpDate,
      mappedOrmd: formValue.mappedOrmd,
      mappedRefrigerateFlag: formValue.mappedRefrigerateFlag,
      mappedIsOralSolid: formValue.mappedIsOralSolid,
      mappedSlotArea: formValue.mappedSlotArea,
      mappedSlotShelf: formValue.mappedSlotShelf,
      mappedSlotBin: formValue.mappedSlotBin,
      mappedLocType: formValue.mappedLocType,
      mappedRop: formValue.mappedRop,
      mappedQtyonShelf: formValue.mappedQtyonShelf,
      mappedLotNo: formValue.mappedLotNo,
      mappedVialSize: formValue.mappedVialSize,
      mappedVialCapacity: formValue.mappedVialCapacity,
      mappedVialEnabled: formValue.mappedVialEnabled,
      mappedVendorPartNo: formValue.mappedVendorPartNo,
      mappedSpecialty: formValue.mappedSpecialty,
      mappedRank: formValue.mappedRank,
      mappedNA: formValue.mappedNA,
      mappedThirtyDramCapacity: formValue.mappedThirtyDramCapacity,
      mappedMaxRecomendedforUse: formValue.mappedMaxRecomendedforUse,
      mappedCellCapacitySmall: formValue.mappedCellCapacitySmall,
      mappedCellCapacityLarge: formValue.mappedCellCapacityLarge,
    };
    const FILEINFOSAVE_KEY = 'Fileinfosavekey'
    const source = Number(formValue?.dataSourceId ?? this.dataSourceId?.value ?? 1);

    this.ngxLoader.start(FILEINFOSAVE_KEY);

    // Gate the API endpoint by the LaunchDarkly flag (USA only):
    // Flag ON + USA  → ValidateCustomerDrugData   (returns matches, opens validation wizard)
    // Flag OFF or Canada → UploadCustomerAndDrugInfo  (original save, skips validation entirely)
    const isValidationActive = this.isDrugValidationActive();
    const apiCall$ = isValidationActive
      ? this.imtoolService.customerAndFileInfoSave(this.customerAndFileInfoModel, source)
      : this.imtoolService.customerAndFileInfoSaveWithoutValidation(this.customerAndFileInfoModel, source);

    apiCall$
      .subscribe(
        (result) => {
          this.ngxLoader.stop(FILEINFOSAVE_KEY);
          if (result.statusCode == 200) {
            this.toastService.openToast(
              result.message,
              constants.ToastPanelType.done,
              2
            );

            if (isValidationActive) {
              // Transform response and open drug validation wizard
              this.drugValidationData = this.transformApiResponseToDrugValidation(result.data);
              this.openDrugValidationWizard();
            } else {
              // Flag OFF or Canada — skip validation, go directly to WI2
              this.hideSide.emit(2);
            }
          } else {
            this.hideSide.emit(1);
            this.toastService.openToast(
              result.message,
              constants.ToastPanelType.error,
              2
            );
          }
        },
        (error: HttpErrorResponse) => {
          this.ngxLoader.stop(FILEINFOSAVE_KEY);
          console.log(error);
          let messageArray = error.error.message.split("|");
          if (messageArray.length < 2) {
            this.toastService.openToast(
              error.error.message ?? error.message,
              constants.ToastPanelType.error,
              2
            );
          }
          else {
            this.toastService.openToast(
              'Multiple errors have been detected. Please review the error list.',
              constants.ToastPanelType.error,
              2
            );
            this.errorMessages = messageArray;
          }
        }
      );
  }




  private progressbarShow(event: any) {
    switch (event.type) {
      case HttpEventType.Sent:
        console.log("Request has been made!");
        break;
      case HttpEventType.ResponseHeader:
        console.log("Response header has been received!");
        break;
      case HttpEventType.UploadProgress:
        var eventTotal = event.total ? event.total : 0;
        this.percentage = Math.round(event.loaded / eventTotal * 100);
        break;
      case HttpEventType.Response:
        if (event.body.succeed) {
          this.fileResponseHandler(event.body.data);
        }
        else {
          this.toastService.openToast(
            event.body.message,
            constants.ToastPanelType.done,
            1
          );
        }


        setTimeout(() => {
          this.percentage = 0;
        }, 2000);
        break;
    }
  }
  private fileResponseHandler(response: ColumnName[]) {

    this.ngxLoader.stop();
    this.toastService.openToast(
      "File successfully uploaded!",
      constants.ToastPanelType.done,
      1
    );
    this.columnNameList = response.map((column) => ({
      name: this.normalizeColumnName(column.name)
    }));
    this.updateColumnList()
  }
  onFileSelected(event: any) {
    console.log("event in onFileSelected " + JSON.stringify(event));
    this.prepareFile(event);
    this.generateExcelPreview(event.target.files[0]);
  }
  onFileDropped(event: any) {
    this.prepareFile(event);
  }
  prepareFile(event: any) {
    this.fielName = event.target.files[0].name;
    this.fieleSelect = true;
    this.fileuploadObject = new DrugFileUpload();
    this.fileuploadObject.FileName = this.fielName;
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (readerEvent: any) => {
      const result = reader.result as string | null;
      if (!result) {
        return;
      }
      const splitVal = result.split(",");
      if (splitVal.length > 0) {
        this.fileuploadObject.FileContent = splitVal[1];
        this.fileContent = this.fileuploadObject.FileContent;
      }
    };
  }
  onRemoveFile() {
    this.openAlertWindow();
  }

  generateExcelPreview(file: File) {
    const reader = new FileReader();

    if (file.name.endsWith('.csv')) {
      reader.onload = () => {
        const text = reader.result as string;
        const rows = text.split('\n');
        
        // Parse CSV rows and handle empty trailing columns
        const parsedRows = rows.map(row => {
          // Use a regex to split by comma while preserving empty values at the end
          // This handles cases where the last column is empty
          const cells = [];
          let currentCell = '';
          let inQuotes = false;
          
          for (const char of row) {
            if (char === '"') {
              inQuotes = !inQuotes;
            } else if (char === ',' && !inQuotes) {
              cells.push(currentCell.trim());
              currentCell = '';
            } else {
              currentCell += char;
            }
          }
          
          // Push the last cell (this handles empty trailing columns)
          cells.push(currentCell.trim());
          
          return cells;
        });
        
        // Find the maximum column count to ensure all rows have the same length
        const maxColumns = Math.max(...parsedRows.map(row => row.length));
        
        // Pad rows with empty strings if they have fewer columns
        this.excelPreviewData = parsedRows
          .map(row => {
            while (row.length < maxColumns) {
              row.push('');
            }
            return row;
          })
          .slice(0, 5);
      };
      reader.readAsText(file);
    } 
    else {
      reader.onload = (e: any) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData: any[][] = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: '' });
        
        // Find the maximum column count to ensure all rows have the same length
        const maxColumns = Math.max(...jsonData.map((row: any[]) => row.length));
        
        // Pad rows with empty strings if they have fewer columns (handles empty trailing cells)
        const normalizedData = jsonData.map((row: any[]) => {
          while (row.length < maxColumns) {
            row.push('');
          }
          return row;
        });
        
        this.excelPreviewData = normalizedData.slice(0, 5);
      };
      reader.readAsArrayBuffer(file);
    }
  }

  openAlertWindow() {
    const dialogRef = this.dialog.open(AlertWizardComponent, {
      backdropClass: ['smDialog'],
      disableClose: true,
      data: {
        alertIcon: "/assets/img/icons/ico.16.alert.svg",
        title: "DELETE CHANGES?",
        bodyMessage: "Are you sure you want to Cancel and delete your changes?",
        bodyMessage2: "This process cannot be undone.",
        cancelBtnText: "Cancel",
        confirmBtnText: "Delete",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.data) {
        this.fielName = "";
        this.fieleSelect = false;
        this.fileUploadButtonShow = true;
        this.columnNameList = [];
        this.drugFileInfoForm.reset();
        this.valueSetAfterResetForm();
        this.excelPreviewData = [];
      } else {
        console.log("Cancel=", result);
      }
    });
  }
  isSelecteMappedMnomonic() {
    const mappedMnemonic = (this.drugFileInfoForm.get('mappedMnemonic')?.value ?? '') as string;
    const hasMnemonic = mappedMnemonic.length > 0;
    this.drugFileInfoForm.controls["isCustomerMnemonic"].setValue(hasMnemonic);
    this.isCustomerMnemonicChange.emit(hasMnemonic);
  }


  valueSetAfterResetForm() {
    this.setUsageValue()
    this.drugFileInfoForm.controls['noUsage'].setValue(false);
    this.drugFileInfoForm.controls['mappedNdcLabel'].setValue(1);
    this.formValidataionUpdate();
    this.deviceId.setValue(1)
    this.countryId.setValue(1)
    this.deviceIdChange.emit(1)
    this.countryIdChange.emit(1)

    // Restore Data Source to its default for the reset device/country combo,
    // otherwise the dropdown shows a blank value after deleting the uploaded file.
    const defaultDataSource = this.getDefaultDataSource(1, 1);
    this.dataSourceId.setValue(defaultDataSource);
    this.dataSourceIdChange.emit(defaultDataSource);
  }

  openImportWizardValidateDrug() {
      if (!this.isDrugValidationActive()) {
        this.hideSide.emit(2);
        return;
      }

   
      const dialogRef = this.dialog.open(ImportWizardValidateCustomerDrugListComponent, {
        panelClass: 'drug-validation-wizard-dialog',
        width: '95vw',
        maxWidth: '1800px',
        height: '90vh',
        disableClose: true,
        data: {
          inputDatalist:this.drugValidationData,
          customerId: this.customerId
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        console.log('===== DIALOG CLOSED =====');
        console.log('Result:', result);
        console.log('Type of result:', typeof result);
        console.log('result.navigateToWI2:', result?.navigateToWI2);
        console.log('result.data:', result?.data);
        console.log('result.event:', result?.event);
        
        if (result && (result.navigateToWI2 || result.data)) {
          console.log('EMITTING hideSide(2) to navigate to WI2');
          this.hideSide.emit(2);
          console.log('hideSide(2) emitted');
        } else {
          console.log('NOT navigating - condition not met');
        }
        console.log('===== END =====');
      });
  }
  //#endregion

}
